import { euro } from '../lib/api';
import type { WonLost } from '../../shared/kpi';

/**
 * Zahl und Wert getrennt beschriftet.
 *
 * Vorher stand „gewonnen, Monat: 2 · 4.000 €" – das liest sich wie „Anzahl in
 * Euro". Anzahl und Summe sind zwei verschiedene Dinge und bekommen deshalb
 * eigene Beschriftungen. Fehlende Beträge werden ausgewiesen, statt die Summe
 * ohne Hinweis kleiner erscheinen zu lassen als die Wirklichkeit.
 */
export function WonLostFigures({ label, value }: { label: string; value: WonLost }) {
  return (
    <div>
      <div className="sm-kpi__label">{label}</div>
      <div className="sm-kpi__value mono">
        {value.count} {value.count === 1 ? 'Deal' : 'Deals'}
      </div>
      <div className="card__meta">
        Wert: <span className="mono">{euro(value.amount)}</span>
        {value.withoutAmount > 0 ? (
          <>
            {' '}
            · {value.withoutAmount} ohne Betrag
          </>
        ) : null}
      </div>
    </div>
  );
}
